import { Component } from '@angular/core';

@Component({
  selector: 'auth',
  template: `<router-outlet></router-outlet>`,
})

export class AuthComponent {
} 